if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.preventResize = false;
      this.ticking = false;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerTop = document.querySelector('.header-top');
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isToggleNav = this.classList.contains('toggle-nav');

      this.calculateThreshold();

      if (this.isToggleNav) {
        this.header.classList.add('toggle-nav');
        this.toggleNavButton = this.querySelector('.header__toggle-nav-button');
        this.onToggleNavClickHandler = this.onToggleNavClick.bind(this);
        this.toggleNavButton.addEventListener('click', this.onToggleNavClickHandler);
        this.nav = this.querySelector('.header__inline-menu');
        setTimeout(() => {
          document.body.style.setProperty('--nav-height', `${this.nav.clientHeight}px`);
        }, 500);
      }

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.setupWindowResizeEvent();
      this.onScroll(); // 初始化状态
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.debouncedOnWindowResize);
      if (this.toggleNavButton) {
        this.toggleNavButton.removeEventListener('click', this.onToggleNavClickHandler);
      }
    }

    calculateThreshold() {
      this.headerBoundTop = this.header.getBoundingClientRect().bottom + (window.pageYOffset || document.documentElement.scrollTop);
      this.threshold = this.headerBoundTop + 100;
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;

      requestAnimationFrame(() => {
        const scrollTop = document.documentElement.scrollTop;

        // 背景填充
        if (scrollTop > 10) {
          this.header.classList.add('header--bg-fill');
        } else {
          this.header.classList.remove('header--bg-fill');
        }

        // 搜索展开时不处理
        if (this.predictiveSearch && this.predictiveSearch.isOpen) {
          this.currentScrollTop = scrollTop;
          this.ticking = false;
          return;
        }

        // 往下滑，隐藏
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBoundTop) {
          this.hide();
        }
        // 往上滑，显示
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBoundTop) {
          if (!this.preventReveal && scrollTop > this.threshold) {
            this.reveal();
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          }
        }
        // 顶部复位
        else if (scrollTop <= this.headerBoundTop) {
          this.reset();
          this.header.classList.remove('header--bg-fill');
        }

        this.currentScrollTop = scrollTop;
        this.ticking = false;
      });
    }

    setupWindowResizeEvent() {
      const headerHeight = this.header.querySelector('header').clientHeight;
      const stickyHeaderHeight = headerHeight + this.getHeaderTopHeight();
      document.body.style.setProperty('--header-height', `${headerHeight}px`);
      if (window.innerWidth >= 990) {
        document.body.style.setProperty('--sticky-header-height-desktop', `${stickyHeaderHeight}px`);
      } else {
        document.body.style.setProperty('--sticky-header-height-mobile', `${stickyHeaderHeight}px`);
      }

      this.debouncedOnWindowResize = debounce(() => this.onWindowResize(), 500);
      window.addEventListener('resize', this.debouncedOnWindowResize, false);
    }

    onWindowResize() {
      if (this.preventResize) return;
      let headerHeight;

      if (this.isToggleNav && window.innerWidth >= 990) {
        const navHeight = this.nav.clientHeight;
        document.body.style.setProperty('--nav-height', `${navHeight}px`);
        headerHeight = this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('open-nav')
          ? this.header.querySelector('header').clientHeight + navHeight + 11
          : this.header.querySelector('header').clientHeight;
      } else {
        headerHeight = this.header.querySelector('header').clientHeight;
      }

      document.body.style.setProperty('--header-height', `${headerHeight}px`);
      const stickyHeaderHeight = headerHeight + this.getHeaderTopHeight();
      if (window.innerWidth >= 990) {
        document.body.style.setProperty('--sticky-header-height-desktop', `${stickyHeaderHeight}px`);
      } else {
        document.body.style.setProperty('--sticky-header-height-mobile', `${stickyHeaderHeight}px`);
      }

      this.calculateThreshold();
    }

    getHeaderTopHeight() {
      return this.headerTop ? this.headerTop.clientHeight : 0;
    }

    onToggleNavClick() {
      document.body.style.setProperty('--nav-height', `${this.nav.clientHeight}px`);
      this.header.classList.toggle('open-nav');
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden');
      this.header.classList.remove('header_h_color');
      this.header.classList.remove('shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.closeToggleNav();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate', 'header_h_color');
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.dataset.toggleNav) this.toggleNavButton.removeAttribute('tabindex');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.closeToggleNav();
    }

    closeToggleNav() {
      if (this.dataset.toggleNav) {
        this.toggleNavButton.setAttribute('tabindex', '-1');
        this.header.classList.remove('open-nav');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(d => d.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  });
}

// 简单防抖函数
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const later = () => {
      timeout = null;
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
